import * as Icons from "lucide-react";

export const RULE_ICONS = [
  ["BookOpen", "Livro"], ["Scale", "Balança"], ["ShieldCheck", "Escudo"], ["Siren", "Sirene"], ["Car", "Carro"], ["Users", "Pessoas"],
  ["Video", "Vídeo / POV"], ["Skull", "Caveira"], ["Flame", "Fogo"], ["MapPin", "Local"], ["Ban", "Proibido"], ["Handshake", "Acordo"],
  ["Gavel", "Martelo"], ["Crosshair", "Mira"], ["Swords", "Espadas"], ["Building2", "Edifício"], ["Briefcase", "Mala"], ["Radio", "Rádio"],
  ["Mic", "Microfone"], ["Heart", "Coração"], ["AlertTriangle", "Aviso"], ["Lock", "Cadeado"], ["Coins", "Moedas"], ["Store", "Loja"],
  ["Stethoscope", "Médico"], ["Wrench", "Ferramenta"], ["Plane", "Avião"], ["Anchor", "Âncora"], ["Zap", "Raio"], ["Star", "Estrela"],
];

const AUTO = [
  [/pov|clip|v[ií]deo|grava/i, "Video"], [/pol[ií]cia|psp|gnr|for[çc]a/i, "Siren"], [/ve[ií]culo|carro|tr[âa]nsito|conduç/i, "Car"],
  [/organiza|gang|fac|ilegal|crime/i, "Skull"], [/redzone|zona vermelha|dark/i, "Crosshair"], [/negocia|acordo|troca/i, "Handshake"],
  [/civil|cidad|conduta/i, "Users"], [/m[ée]dic|ems|hospital|inem/i, "Stethoscope"], [/geral|conceito|defini/i, "BookOpen"],
  [/san[çc]|puni|ban/i, "Gavel"], [/rob|assalt|roubo/i, "Lock"], [/econom|dinheiro|edens|loja/i, "Coins"],
];

export function ruleIconName(category) {
  if (category?.icon && Icons[category.icon]) return category.icon;
  const hit = AUTO.find(([re]) => re.test(category?.title || ""));
  return hit ? hit[1] : "BookOpen";
}

export function RuleIcon({ category, size = 18, className = "" }) {
  const Icon = Icons[ruleIconName(category)] || Icons.BookOpen;
  return <Icon size={size} className={className} aria-hidden="true" />;
}
